import * as permission from 'common-module/src/config/permission';

/**
 * 重写自动生成路由配置
 * key为路由path,多级为path.path
 * value如果为字符串则替换path，为对象则合并
 */
export default {
  'insights': {
    meta: {
      ...permission.insightsPage
    }
  },
  'insights/development': {
    meta: {
      ...permission.insightsPage
    }
  },
  'insights/team-activity': {
    meta: {
      ...permission.insightsPage
    }
  },
  'insights/trend': {
    meta: {
      ...permission.insightsPage
    }
  },
  'insights/work': {
    meta: {
      ...permission.insightsPage
    }
  },
  'release': {
    meta: {
      ...permission.integrationReleaseView
    }
  },
  'release/detail': {
    meta: {
      ...permission.integrationReleaseView
    }
  },
  'roadmap': {
    meta: {
      ...permission.roadmapPage
    }
  },
  'team': {
    meta: {
      ...permission.teamPage
    }
  }
};
